import { BattleRoundResults } from "../../../../../domain/battles/BattleRoundResults.js";
import type { BattleRoomResultsContent } from "../../../battlesContent.js";

/** What every seat has pulled so far, lit seat by seat as each reel lands. */
export function BattleRoomResults({
  label,
  lanes,
  roundCount,
  roundLabel,
  winnerLabel,
}: BattleRoomResultsContent) {
  return (
    <BattleRoundResults
      label={label}
      lanes={lanes}
      roundCount={roundCount}
      roundLabel={roundLabel}
      winnerLabel={winnerLabel}
    />
  );
}
